import { Empty } from 'antd'

const EmptyCommon = () => {
  return <Empty description={<p style={{ color: '#B5B5C3' }}>データがありません</p>} />
}

export default EmptyCommon
